import React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { useAdminOrganizationsQuery } from '../../api/admin';
import AdminGridLink from './AdminGridLink';
import AdminQuickFilterToolbar from './AdminQuickFilterToolbar';

const columns: GridColDef[] = [
	{
		field: 'name',
		headerName: 'Organization',
		flex: 1.5,
		minWidth: 200,
		renderCell: (params: GridRenderCellParams) => (
			<AdminGridLink
				to={`/admin/organizations/${params.row.id}`}
				state={{ organizationName: params.row.name }}
			>
				{params.value}
			</AdminGridLink>
		),
	},
	{ field: 'team_count', headerName: 'Teams', width: 100, type: 'number' },
	{ field: 'user_count', headerName: 'Users', width: 100, type: 'number' },
	{
		field: 'description',
		headerName: 'Description',
		flex: 2,
		minWidth: 160,
	},
	{
		field: 'created_at',
		headerName: 'Created',
		width: 120,
		valueFormatter: ({ value }) => (value ? new Date(value).toLocaleDateString('en-CA') : ''),
	},
];

export default function OrganizationsTable() {
	const { data: organizations, isLoading } = useAdminOrganizationsQuery();

	return (
		<Box sx={{ height: 'calc(100vh - 310px)', width: '100%' }}>
			<DataGrid
				rows={organizations ?? []}
				columns={columns}
				loading={isLoading}
				density="compact"
				disableSelectionOnClick
				components={{ Toolbar: AdminQuickFilterToolbar }}
				componentsProps={{ toolbar: { showQuickFilter: true } }}
			/>
		</Box>
	);
}
